'use strict';

const alert = {
  bindings: {
    data: '<'
  },
  template: `
    <div class="alert-box" ng-class="$ctrl.data.type" ng-if="$ctrl.data.message.length">
      <div ng-bind-html="$ctrl.data.message | html"></div>
    </div>
  `
};

angular
  .module('sr.alert', [])
  .component('alert', alert);
